/* The live Forms app block submits to Shopify. Demo inputs are never transmitted or stored. */
(() => {
  const instances = new Map();
  function initialize(root = document) {
    root.querySelectorAll('[data-tv-welcome]').forEach(container => {
      if (instances.has(container)) return;
      const dialog = container.querySelector('dialog');
      const teaser = container.querySelector('[data-tv-welcome-open]');
      if (!dialog || typeof dialog.showModal !== 'function') { teaser.hidden = true; return; }
      const controller = new AbortController();
      const { signal } = controller;
      const demo = container.dataset.tvWelcomeMode === 'demo';
      const key = `tnlvzn-welcome-seen-v1-${demo ? 'demo' : 'live'}`;
      const form = container.querySelector('[data-tv-welcome-demo-form]');
      const formView = container.querySelector('[data-tv-welcome-form-view]');
      const success = container.querySelector('[data-tv-welcome-success]');
      const fallback = container.querySelector('[data-tv-form-fallback]');
      const hasForm = root => !!root.querySelector('input[type="email"], form') || Array.from(root.querySelectorAll('*')).some(el => el.shadowRoot && hasForm(el.shadowRoot));
      let formReady = demo;
      const updateReady = () => {
        formReady = demo || Array.from(container.querySelectorAll('[data-form-root]')).some(hasForm);
        if (fallback) fallback.hidden = formReady;
      };
      const observer = new MutationObserver(updateReady);
      observer.observe(container, { childList: true, subtree: true });
      const readyPoll = setInterval(updateReady, 1000);
      const stopPoll = setTimeout(() => clearInterval(readyPoll), 30000);
      updateReady();
      let previousFocus;
      let timer;
      let seen = false;
      try { seen = localStorage.getItem(key) === '1'; } catch { /* Storage can be blocked; the teaser still works. */ }
      const resetDemo = () => {
        if (!demo) return;
        form.reset();
        formView.hidden = false;
        success.hidden = true;
      };
      const open = () => {
        if (dialog.open || document.querySelector('dialog[open]')) return;
        clearTimeout(timer);
        resetDemo();
        previousFocus = document.activeElement;
        dialog.showModal();
        document.documentElement.classList.add('tv-welcome-open');
        seen = true;
        // Persist only a display preference, never an email address or phone number.
        try { localStorage.setItem(key, '1'); } catch { /* Optional storage. */ }
      };
      const afterClose = () => {
        document.documentElement.classList.remove('tv-welcome-open');
        if (demo) form.reset();
        if (previousFocus?.isConnected && previousFocus !== document.body) previousFocus.focus({ preventScroll: true });
      };
      const close = () => { dialog.close(); afterClose(); };
      teaser.addEventListener('click', open, { signal });
      container.querySelectorAll('[data-tv-welcome-close]').forEach(button => button.addEventListener('click', close, { signal }));
      dialog.addEventListener('close', afterClose, { signal });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      }, { signal });
      if (demo && form) {
        form.addEventListener('submit', event => {
          event.preventDefault();
          if (!form.reportValidity()) return;
          form.reset();
          formView.hidden = true;
          success.hidden = false;
          success.focus({ preventScroll: true });
        }, { signal });
      }
      if (!seen) {
        timer = setTimeout(() => {
          // Avoid interrupting a purchase, another modal, an open menu or someone typing.
          if (document.visibilityState === 'hidden' || document.querySelector('dialog[open], .tv-mobile-menu[open]')) return;
          if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return;
          if (formReady) open();
        }, Number(container.dataset.tvWelcomeDelay) || 8000);
      }
      instances.set(container, () => {
        clearTimeout(timer);
        if (dialog.open) close();
        observer.disconnect();
        clearInterval(readyPoll);
        clearTimeout(stopPoll);
        controller.abort();
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, container) => {
      if (!event.target.contains(container)) return;
      cleanup();
      instances.delete(container);
    });
  });
})();
